import { render, staticRenderFns } from "./OrderAdditionalInfo.vue?vue&type=template&id=17e38d5f&scoped=true"
import script from "./OrderAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./OrderAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderAdditionalInfo.vue?vue&type=style&index=0&id=17e38d5f&prod&lang=css"
import style1 from "./OrderAdditionalInfo.vue?vue&type=style&index=1&id=17e38d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e38d5f",
  null
  
)

export default component.exports